<div class="cog-shell">
  <!-- B5: shared check-in progress header (step 3 of 4). The global bar comes
       only from [step], so it never resets when moving between cognitive tasks;
       the moving task name + trial counter ride on the in-section line/bar. -->
  <app-checkin-progress
    *ngIf="isInTestSequence"
    [step]="3"
    [detail]="cogDetail"
    [subPct]="progressPct"
  ></app-checkin-progress>

  <!-- INTRO -->
  <div *ngIf="phase === 'intro'" class="cog-screen">
    <div class="cog-spacer intro-top-spacer"></div>

    <div class="cog-text-center cog-mb-16">
      <h1 class="cog-h1">
        {{ 'cognitive.intro.title' | translate }}
      </h1>
    </div>

    <div class="cog-card cog-card-accent">
      <p class="intro-blurb">{{ 'cognitive.intro.blurb' | translate }}</p>
      <div *ngIf="showWhy" class="intro-more">
        <p>{{ 'cognitive.intro.more1' | translate }}</p>
        <p>{{ 'cognitive.intro.more2' | translate }}</p>
        <p class="dive-deeper">{{ 'cognitive.intro.diveDeeper' | translate }}</p>
        <div class="intro-links">
          <a href="https://pubmed.ncbi.nlm.nih.gov/37755656/" target="_blank" rel="noopener">
            &rarr; {{ 'cognitive.intro.link1' | translate }}
          </a>
          <a href="https://www.nature.com/articles/s41598-021-90084-y" target="_blank" rel="noopener">
            &rarr; {{ 'cognitive.intro.link2' | translate }}
          </a>
          <a href="https://pubmed.ncbi.nlm.nih.gov/34836334/" target="_blank" rel="noopener">
            &rarr; {{ 'cognitive.intro.link3' | translate }}
          </a>
        </div>
      </div>
      <button type="button" class="intro-why-toggle" (click)="showWhy = !showWhy">
        {{ (showWhy ? 'cognitive.intro.showLess' : 'cognitive.intro.whyHappen') | translate }}
      </button>
    </div>

    <div class="cog-card intro-meta-card">
      <div class="intro-meta-grid">
        <div>
          <div class="cog-label">{{ 'cognitive.intro.duration' | translate }}</div>
          <div class="meta-value">{{ 'cognitive.intro.durationValue' | translate }}</div>
        </div>
        <div>
          <div class="cog-label">{{ 'cognitive.intro.activities' | translate }}</div>
          <div class="meta-value subtle">{{ 'cognitive.intro.activitiesValue' | translate }}</div>
        </div>
      </div>
      <div class="intro-chips">
        <span class="cog-chip">{{ 'cognitive.intro.chipSpeed' | translate }}</span>
        <span class="cog-chip">{{ 'cognitive.intro.chipWords' | translate }}</span>
        <span class="cog-chip">{{ 'cognitive.intro.chipMemory' | translate }}</span>
        <span class="cog-chip">{{ 'cognitive.intro.chipRecall' | translate }}</span>
      </div>
    </div>

    <div class="cog-spacer"></div>

    <!-- Autosave: a run that was interrupted is picked up where it stopped, and
         says so, rather than silently dropping her into the middle of a task. -->
    <p *ngIf="resumePhase" class="cog-resume-note">
      {{ 'cognitive.intro.resumeNote' | translate: { done: resumeDone, total: totalTests } }}
    </p>

    <button class="cog-btn cog-btn-primary" (click)="startTests()">
      {{ (resumePhase ? 'cognitive.intro.resumeCta' : 'cognitive.intro.begin') | translate }}
    </button>

    <div class="cog-disclaimer">
      {{ 'cognitive.intro.disclaimer' | translate }}
    </div>
  </div>

  <!-- TEST RUNNERS -->
  <div *ngIf="isInTestSequence" class="cog-screen test-screen">
    <div class="phase-host" [ngSwitch]="phase">
      <app-recall-encode
        *ngSwitchCase="'recall-encode'"
        (testComplete)="onTestComplete($event)"
      ></app-recall-encode>

      <app-constellation-catch
        *ngSwitchCase="'constellation'"
        (testComplete)="onTestComplete($event)"
      ></app-constellation-catch>

      <app-word-garden
        *ngSwitchCase="'word-garden'"
        (testComplete)="onTestComplete($event)"
      ></app-word-garden>

      <app-echo-chamber
        *ngSwitchCase="'echo-chamber'"
        (testComplete)="onTestComplete($event)"
      ></app-echo-chamber>

      <app-memory-scene
        *ngSwitchCase="'memory-scene'"
        (testComplete)="onTestComplete($event)"
      ></app-memory-scene>
    </div>
  </div>

  <!-- TRANSITION (part D #5: a meaning screen, not an end — vision + hearing next) -->
  <div *ngIf="phase === 'transition'" class="cog-screen cog-transition">
    <div class="cog-spacer"></div>

    <div class="cog-text-center cog-mb-16">
      <h1 class="cog-h1">{{ 'cognitive.sharpV2.transition.title' | translate }}</h1>
    </div>

    <div class="cog-card cog-card-accent">
      <p class="cog-transition-line" *ngIf="recallBandKey">
        {{ recallBandKey | translate }}
        {{ 'cognitive.sharpV2.transition.startingPoint' | translate }}
      </p>
    </div>

    <div class="cog-disclaimer cog-transition-disclaimer">
      {{ 'cognitive.sharpV2.transition.disclaimer' | translate }}
    </div>

    <div class="cog-spacer"></div>

    <button
      class="cog-btn cog-btn-primary"
      type="button"
      [disabled]="continueBusy"
      (click)="continueFromTransition()"
    >
      {{ 'cognitive.sharpV2.transition.continue' | translate }}
    </button>
  </div>

  <!-- SAVING -->
  <div *ngIf="phase === 'saving'" class="cog-screen">
    <div class="cog-spacer"></div>
    <div class="cog-text-center">
      <p class="cog-subtitle">{{ 'cognitive.sharpV2.saving' | translate }}</p>
    </div>
    <div class="cog-spacer"></div>
  </div>
</div>
